const min = Number.MIN_SAFE_INTEGER;
const max = Number.MAX_SAFE_INTEGER;

const generateActionId = (): number => {
  return Math.floor(Math.random() * (max - min + 1) + min);
};

export default generateActionId;
